import React, { useEffect, useState } from "react";
import { About } from "../../../components/Rental/Layout/About";
import { Footer } from "../../../components/SpearParts/Layouts/Footer";
import { useNavigate } from "react-router-dom";
import Axios from "../../../axios/axios";
import TopNavBar from "../../../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../../../components/SpearParts/Layouts/TopSearchBar";
import './NewRentalHome.css'
import RntMiddle from "../../../components/Rental/Layout/RntMiddle";
import Catalogue from "../../../components/Rental/Layout/Catalogue";
import Brand from "../../../components/Rental/Layout/Brand";
import { NewAbout } from "../../../components/Rental/Layout/NewAbout";

// ✅ Fetch rental-related data (brands, models, categories)
export const getCompleteRentalData = async (
  setRentalModels,
  setRentalBrands,
  setRentalCategories
) => {
  try {
    const response = await Axios.get("/rental/type-based-details"); // 👈 API endpoint for rental
    console.log("Rental API Response:", response.data);
    setRentalModels(response.data.rental.models || []);
    setRentalBrands(response.data.rental.brands || []);
    setRentalCategories(response.data.rental.categories || []);
  } catch (error) {
    console.error("Error fetching rental details:", error);
  }
};

export const getRentalRegions = async (setRegion) => {
  try {
    const response = await Axios.get("/rental/regions");
    setRegion(response.data || []);
  } catch (error) {
    console.error("Error fetching rental regions:", error);
  }
};

export const getYears = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: currentYear - 2000 + 1 }, (_, i) => 2000 + i);
};

export const searchRentalItems = async (filters, page = 1, limit = 10) => {
  try {
    const params = new URLSearchParams({ ...filters, page, limit });
    const response = await Axios.post(`/rental/search?${params.toString()}`);
    return response.data || { data: [], total: 0, pages: 0, page };
  } catch (error) {
    console.error("Error fetching rental items:", error);
    return { data: [], total: 0, pages: 0, page };
  }
};

function NewRentalHome() {
  const [rentalModels, setRentalModels] = useState([]);
  const [rentalBrands, setRentalBrands] = useState([]);
  const [rentalCategories, setRentalCategories] = useState([]);
  const [rentalRegions, setRentalRegions] = useState([]);

  useEffect(() => {
    getCompleteRentalData(
      setRentalModels,
      setRentalBrands,
      setRentalCategories
    );
    getRentalRegions(setRentalRegions);
  }, []);

   const sectionStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundImage: "url(/images/bnr-bg.png)",
  };

  const beforeImageStyle = {
    content: '""',
    position: "absolute",
    left: 0,
    top: "50px",
    width: "400px",
    height: "100%",
    backgroundImage: "url(/images/rental-before.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left top",
    backgroundSize: "contain",
    pointerEvents: "none",
    zIndex: 1,
  };

  const afterImageStyle = {
    content: '""',
    position: "absolute",
    right: 0,
    bottom: "290px",
    width: "200px",
    height: "90%",
    backgroundImage: "url(/images/rental-after.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right bottom",
    backgroundSize: "contain",
    pointerEvents: "none",
    zIndex: 1,
  };

  return (
    <>
      <div className="New-Rnt-Dashboard" style={sectionStyle}>
        <div className="before-image" style={beforeImageStyle}></div>
        <div className="after-image" style={afterImageStyle}></div>
        <div className="New-Rnt-Dashboard-container">
          <TopNavBar />
          <div className="TopSearchBar">
            <TopSearchBar />
          </div>
          <div className="Middle-position">
            {" "}
            <RntMiddle />
          </div>
          <div className="Catalogue-Position">
            <Catalogue />
          </div>
        </div>
      </div>

      <div className="New-Rnt-Dashboard-container Brand-position">
        <Brand />
        <NewAbout />
      </div>
    </>
  );
}

export default NewRentalHome;
